import { Component, inject, Input } from "@angular/core";
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { ProjectService } from "@domain/project/project.service";
import { UserService } from "@domain/user/user.service";
import { filter, map, Observable } from "rxjs";

@Component({
  selector: "app-checklist-item",
  templateUrl: "./checklist-item.component.html",
  styleUrls: ["./checklist-item.component.scss"],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  imports: [UiKitModule, ReactiveFormsModule],
  standalone: true,
})
export class ChecklistItemComponent {
  private userService = inject(UserService);
  private projectService = inject(ProjectService);

  protected isReadOnlyUser$: Observable<boolean>;
  protected hasWritePermission$: Observable<boolean | undefined>;

  @Input()
  label!: string;

  @Input()
  groupName!: string;

  @Input()
  notesPlaceholder = $localize`:@@checklistItem.textarea.placeholder:Notes`;

  @Input()
  disabled = false;

  constructor() {
    this.isReadOnlyUser$ = this.userService.user$.pipe(map((user) => user.readOnlyAccess));
    this.hasWritePermission$ = this.projectService.hasUserWritePermission$.pipe(
      filter((val): val is boolean => val !== undefined),
    );
  }

  protected readonly navigator = navigator;
}
